import {Grid, Box, styled, Button} from '@mui/material';
import {Link} from 'react-router-dom';
import {Color} from '../../../common/theme';

const BackgroundBox = styled(Box)({
    paddingTop: 54,
    paddingBottom: 54,
    paddingLeft: 32,
    paddingRight: 32,
    margin: 0,
    backgroundColor: Color.SEA_GREEN,
});

export const ContactUsSection = () => {
    return (
        <BackgroundBox>
            <Grid container>
                <Grid item md={3} />
                <Grid item md={6}>
                    <span
                        style={{
                            fontSize: 32,
                            color: Color.WHITE,
                            fontWeight: 700,
                            fontFamily: 'Poppins',
                        }}>
                        <center>Contact Us</center>
                    </span>
                </Grid>
            </Grid>
            <Grid style={{marginTop: 12}} container>
                <Grid item md={2} />

                <Grid item md={8}>
                    <span
                        style={{
                            fontSize: 16,
                            color: Color.WHITE,
                            fontWeight: 200,
                            fontFamily: 'Poppins',
                        }}>
                        <center>
                            Drop us an email at <a href='mailto:hello@socialmart.com'>hello@socialmart.com</a>
                            <br />
                            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '16px' }}>
                                <Button
                                    component={Link}
                                    to="/terms-and-conditions"
                                    variant="outlined"
                                    size="small"
                                    style={{
                                        color: Color.WHITE,
                                        borderColor: Color.WHITE,
                                        fontWeight: 500,
                                        padding: '6px 16px',
                                    }}
                                >
                                    TERMS OF SERVICE
                                </Button>
                                <Button
                                    component={Link}
                                    to="/privacy-policy"
                                    variant="outlined"
                                    size="small"
                                    style={{
                                        color: Color.WHITE,
                                        borderColor: Color.WHITE,
                                        fontWeight: 500,
                                        padding: '6px 16px',
                                    }}
                                >
                                    PRIVACY POLICY
                                </Button>
                            </div>
                        </center>
                    </span>
                </Grid>
            </Grid>
        </BackgroundBox>
    );
};
